import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import dayjs from "dayjs"
import UsageTable, { formatCount } from "./UsageTable"
import ModuleAccessByType from "./ModuleAccessByType"
import UserAccessTable from "./UserAccessTable"
import ActivityMetrics from "./ActivityMetrics"

const EnterpriseDetails = ({ enterprise, data, onClose }) => {
    if (!enterprise)
        return null

    const rows = (kind) => data[kind].map(definition => ({ ...definition, ...enterprise[kind][definition.id] }))

    return (
        <Dialog open onClose={onClose} maxWidth="xl" fullWidth aria-labelledby="usage-enterprise-title">
            <DialogTitle id="usage-enterprise-title">{enterprise.name}</DialogTitle>
            <DialogContent dividers>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                    <Typography variant="body2" color="text.secondary">
                        Empresa · Plano: {enterprise.plan_name || "Sem plano vinculado"}
                    </Typography>
                    <Typography variant="body2">
                        Usuários licenciados: {formatCount(enterprise.licensed_users)} · Usuários cadastrados: {formatCount(enterprise.registered_users)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Quantidades atuais. Cadastrados incluem ativos e inativos; usuários excluídos não entram nessa quantidade.
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Disponibilidade atual · Uso de {dayjs(data.period.start).format("DD/MM/YYYY")} a {dayjs(data.period.end).format("DD/MM/YYYY")}
                    </Typography>
                    <Typography variant="body2">
                        Usuários ativos 7d: {formatCount(enterprise.active_users_7d)} · Ativos 30d: {formatCount(enterprise.active_users_30d)} ·
                        Adoção de usuários 7d / 30d: {enterprise.user_adoption_7d == null ? "—" : `${formatCount(enterprise.user_adoption_7d)} %`} / {enterprise.user_adoption_30d == null ? "—" : `${formatCount(enterprise.user_adoption_30d)} %`}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Primeiro uso conhecido: {enterprise.first_used ? dayjs(enterprise.first_used).format("DD/MM/YYYY") : "—"} ·
                        Última atividade conhecida: {enterprise.last_used ? dayjs(enterprise.last_used).format("DD/MM/YYYY") : "—"} ·
                        Dias desde o último uso: {formatCount(enterprise.days_since_use)}.
                        Datas no histórico coletado até a referência, não somente no período filtrado; ausência de registro não comprova ausência de uso anterior à coleta.
                    </Typography>
                    {enterprise.is_suspended && <Alert severity="warning">Cadastro suspenso. As habilitações abaixo estão cadastradas, mas a suspensão bloqueia o acesso.</Alert>}
                    <ModuleAccessByType enterprise={enterprise} rows={rows("modules")} />
                    <UserAccessTable users={enterprise.users || []} modules={data.modules} />
                    {!enterprise.used && <Alert severity="info">Nenhuma atividade registrada nas métricas aferidas neste período. Acessos às telas são contabilizados separadamente.</Alert>}
                    <Alert severity="info">
                        Entradas no módulo contam cada abertura ou retorno, inclusive retornos rápidos e recargas da página, separados das atividades realizadas.
                        Na Agenda, a abertura da guia também conta como uso.
                        Coleta somente após a publicação do contador, sem histórico retroativo. Não mede tempo de permanência; falhas de conexão podem impedir registros.
                    </Alert>
                    <UsageTable title="Módulos e funcionalidades" rows={rows("modules")} detail />
                    <ActivityMetrics rows={enterprise.activity_metrics} />
                    <UsageTable title="Canais" rows={rows("channels")} channels detail />
                    <Typography variant="body2" color="text.secondary">
                        “Atividade não contabilizada” indica uma limitação desta tela, não um erro de consulta nem valor zero.
                        Habilitação empresarial não substitui as permissões individuais dos usuários. Envios e atendimentos não são somados.
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions><Button onClick={onClose}>Fechar</Button></DialogActions>
        </Dialog>
    )
}

export default EnterpriseDetails
